import { Checkbox, FormControlLabel, FormGroup, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import '../../css/botao.css';
import ReactComponent from '../ReactComponent';

class FiltroBooleano extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            filtro: computed,
            opcoes: computed,
            labelTrue: computed,
            labelFalse: computed,
            alterarValorFiltro: action,
            handleClickCheckbox: action
        });
    }

    async componentDidMount() {
        try {
            await this.filtro.carregarDadosComplementares();
        } catch (error) {
            console.error(`Falha na inicialização do componente FiltroBooleano: ${ErrorUtil.getMensagemErro(error)}`);
            throw new Error('Falha na inicialização do componente FiltroBooleano', { cause: error });
        }
    }

    get filtro() {
        return this.store.filtros[this.observableProps.idFiltro];
    }

    get opcoes() {
        let opcoes = [
            { label: this.labelTrue, value: true, totalizadores: [] },
            { label: this.labelFalse, value: false, totalizadores: [] }
        ];

        opcoes.forEach((opcao) => {
            this.store.opcoesProcessosEmExibicao.forEach((opcaoProcessos) =>
                // @ts-ignore
                opcao.totalizadores.push({
                    descricao: opcaoProcessos.descricao,
                    quantidade: this.filtro._filtrarProcessosBooleano(opcaoProcessos.funcaoProcessos(), opcao.value)
                        .length,
                    quantidadeFiltrados: this.filtro._filtrarProcessosBooleano(
                        opcaoProcessos.funcaoProcessosFiltrados(),
                        opcao.value
                    ).length
                })
            );

            opcao.quantidadeTotal = opcao.totalizadores.reduce(
                // @ts-ignore
                (acc, totalizador) => (acc += totalizador.quantidade),
                0
            );
        });
        return opcoes;
    }

    get labelTrue() {
        return this.filtro.getDescricao(true);
    }

    get labelFalse() {
        return this.filtro.getDescricao(false);
    }

    alterarValorFiltro(valor) {
        this.store.alterandoValorFiltro = true;
        setTimeout(
            () =>
                runInAction(() => {
                    this.filtro.valor = valor;
                    this.store.alterandoValorFiltro = false;
                }),
            1
        );
    }

    handleClickCheckbox = (event) => {
        if (!event.target.checked) {
            this.alterarValorFiltro(undefined);
        } else {
            this.alterarValorFiltro(event.target.value === this.labelTrue);
        }
    };

    renderOpcaoComQuantidades(opcao) {
        return (
            <div style={{ fontSize: '0.9rem' }}>
                <div style={{ fontWeight: 'bold' }}>{opcao.label}</div>
                {' ('}
                <span>
                    {opcao.totalizadores
                        .map((totalizador) => totalizador.descricao + ': ' + totalizador.quantidadeFiltrados)
                        .join('; ')}
                </span>
                {')'}
            </div>
        );
    }

    renderTotalizadoresSessao() {
        return (
            <div>
                <Typography>{'Total de processos na sessão (' + this.filtro.label + ')'}</Typography>
                {this.opcoes.map((opcao) => (
                    <Typography
                        key={this.nextKey}
                        display="inline"
                    >
                        {opcao.label + ': '}
                        {opcao.totalizadores
                            // @ts-ignore
                            .map((totalizador) => `${totalizador.descricao}: ${totalizador.quantidade}`)
                            .join('; ')}
                    </Typography>
                ))}
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.filtro && !this.filtro.ocultaFiltro ? (
                    <div style={{ marginTop: '7px' }}>
                        <Tooltip
                            placement="top"
                            title={this.renderTotalizadoresSessao()}
                        >
                            <Typography
                                variant="subtitle2"
                                color="inherit"
                                style={{ paddingBottom: '5px ' }}
                            >
                                {this.filtro.label}
                            </Typography>
                        </Tooltip>
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '8px' }}>
                            {this.filtro.carregandoDadosComplementares
                                ? this.filtro.renderCarregando()
                                : this.renderComponente()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderComponente() {
        return (
            <FormGroup row>
                {this.opcoes.map((opcao) => (
                    <FormControlLabel
                        key={'FCL' + opcao.value}
                        label={this.renderOpcaoComQuantidades(opcao)}
                        style={{ width: '330px', alignItems: 'flex-start' }}
                        control={
                            <Checkbox
                                color="primary"
                                style={{ paddingTop: '0px' }}
                                value={opcao.label}
                                onClick={this.handleClickCheckbox}
                                checked={this.filtro.valor === (opcao.label === this.labelTrue)}
                            />
                        }
                    />
                ))}
            </FormGroup>
        );
    }
}

export default inject('stores')(observer(FiltroBooleano));
